import styled from '@emotion/styled';

const TagList = styled('ul')(({ theme }) => ({
  marginTop: 12,
  marginBottom: 12,
  paddingLeft: 0,
  minWidth: 300,
  listStyle: 'none',
  li: {
    display: 'flex',
    alignItems: 'center',
    '.MuiCheckbox-root': {
      color: theme.palette.text.secondary,
    },
  },
}));

export default TagList;
